import type { Pouch } from '../types';

/** scale 適用後の値（round 前） */
export function getPouchScaledValue(
  p: Pick<Pouch, 'value' | 'multiplier' | 'isTime'>,
  valueOverride?: number,
  multiplierOverride?: number,
): number {
  const value = valueOverride !== undefined ? valueOverride : p.value;
  const multiplier = multiplierOverride !== undefined ? multiplierOverride : p.multiplier;
  if (p.isTime === true) {
    return value * multiplier;
  }
  return multiplier < 0 ? value / Math.abs(multiplier) : value * multiplier;
}

/** roundUnit を scale 済み値に適用 */
export function roundScaledValue(scaled: number, roundUnit?: number): number {
  if (roundUnit === undefined || roundUnit <= 0) {
    return scaled;
  }
  return Math.round(scaled / roundUnit) * roundUnit;
}

/** scale 後の小計（|scaled|）を上限に roundUnit を clamp */
export function clampRoundUnitToAbsoluteCap(
  roundUnit: number | undefined,
  scaledCapAbs: number,
): number | undefined {
  if (roundUnit === undefined || roundUnit <= 0) {
    return undefined;
  }
  const maxAllowed = scaledCapAbs > 0 ? scaledCapAbs : 0;
  return roundUnit > maxAllowed ? undefined : roundUnit;
}

/**
 * scale 後の小計（|scaled|）を超える roundUnit は無効。
 * 値・数量変更後に自動クリアする（roundUnitShift の上限と同じ基準）。
 */
export function clampRoundUnitToScaledCap(
  roundUnit: number | undefined,
  p: Pick<Pouch, 'value' | 'multiplier' | 'isTime'>,
  valueOverride?: number,
  multiplierOverride?: number,
): number | undefined {
  const cap = Math.abs(getPouchScaledValue(p, valueOverride, multiplierOverride));
  return clampRoundUnitToAbsoluteCap(roundUnit, cap);
}

/** 実効寄与: scale 後に roundUnit があれば N 単位丸め（時間パウチは実効分数に適用） */
export function applyPouchScaleAndRound(
  p: Pick<Pouch, 'value' | 'multiplier' | 'isTime' | 'roundUnit'>,
  valueOverride?: number,
  multiplierOverride?: number,
): number {
  const scaled = getPouchScaledValue(p, valueOverride, multiplierOverride);
  return roundScaledValue(scaled, p.roundUnit);
}
